import { useEffect, useRef, useState } from 'react';

const AdSense = ({ 
  client = "ca-pub-9246308882426419", 
  slot, 
  format = "auto", 
  style = { display: 'block' },
  className = "",
  responsive = true 
}) => {
  const adRef = useRef(null);
  const [adLoaded, setAdLoaded] = useState(false);
  const [adError, setAdError] = useState(false);

  useEffect(() => {
    const loadAd = () => {
      try {
        // Check if adsbygoogle is available
        if (typeof window !== 'undefined' && window.adsbygoogle && adRef.current) {
          // Clear any existing content
          adRef.current.innerHTML = '';
          
          // Push the ad
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          setAdLoaded(true);
          setAdError(false);
        } else if (typeof window !== 'undefined') {
          // If adsbygoogle is not available yet, try again in a bit
          setTimeout(loadAd, 100);
        }
      } catch (error) {
        console.error('AdSense error:', error);
        setAdError(true);
        setAdLoaded(false);
      }
    };

    // Small delay to ensure the DOM is ready
    const timer = setTimeout(loadAd, 100);
    
    return () => clearTimeout(timer);
  }, [client, slot, format]);

  if (!slot) {
    console.warn('AdSense: slot prop is required');
    return null;
  }

  return (
    <div className={`adsense-container ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={style}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
      {/* Debug info - remove in production */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{fontSize: '10px', color: '#999', marginTop: '5px'}}>
          {adError ? '❌ Ad Error' : adLoaded ? '✅ Ad Loaded' : '⏳ Loading...'}
        </div>
      )}
    </div>
  );
};

export default AdSense;
